import {
    FETCH_WELLNESS_DAILY_SLEEP_DATA_FETCHING,
    FETCH_WELLNESS_DAILY_SLEEP_DATA_SUCCESS,
    FETCH_WELLNESS_DAILY_SLEEP_DATA_FAIL,
    UPDATE_WELLNESS_SLEEP_NOTE_START,
    UPDATE_WELLNESS_SLEEP_NOTE_SUCCESS,
    UPDATE_WELLNESS_SLEEP_NOTE_FAIL
} from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    payload: {},
    dailySleeps: {},
    isFetching: {},
    fetchFailed: {},
    noteUpdating: false,
    noteUpdateFailed: false,
    lastNote: ''
};

const fetchDailySleepDataFetching = (state, action) => {
    return {
        ...state,
        isFetching: {
            ...state.isFetching,
            [action.displayName]: {
                ...state.isFetching[action.displayName],
                [action.calendarDate]: true
            }
        },
        fetchFailed: {
            ...state.fetchFailed,
            [action.displayName]: {
                ...state.fetchFailed[action.displayName],
                [action.calendarDate]: false
            }
        }
    };
};

const fetchDailySleepDataSuccess = (state, action) => {
    return {
        ...state,
        payload: action.dailySleepData,
        dailySleeps: {
            ...state.dailySleeps,
            [action.displayName]: {
                ...state.dailySleeps[action.displayName],
                [action.calendarDate]: action.dailySleepData
            }
        },
        isFetching: {
            ...state.isFetching,
            [action.displayName]: {
                ...state.isFetching[action.displayName],
                [action.calendarDate]: false
            }
        },
        fetchFailed: {
            ...state.fetchFailed,
            [action.displayName]: {
                ...state.fetchFailed[action.displayName],
                [action.calendarDate]: false
            }
        },
        noteUpdateFailed: INITIAL_STATE.noteUpdateFailed,
        lastNote: action.dailySleepData.dailySleepDTO.userNote
    };
};

const fetchDailySleepDataFail = (state, action) => {
    return {
        ...state,
        payload: action.dailySleepData,
        dailySleeps: {
            ...state.dailySleeps,
            [action.displayName]: {
                ...state.dailySleeps[action.displayName],
                [action.calendarDate]: {}
            }
        },
        isFetching: {
            ...state.isFetching,
            [action.displayName]: {
                ...state.isFetching[action.displayName],
                [action.calendarDate]: false
            }
        },
        fetchFailed: {
            ...state.fetchFailed,
            [action.displayName]: {
                ...state.fetchFailed[action.displayName],
                [action.calendarDate]: true
            }
        }
    };
};

const updateSleepNoteStart = (state, action) => {
    const { userNote, displayName, calendarDate } = action;

    return {
        ...state,
        dailySleeps: {
            ...state.dailySleeps,
            [displayName]: {
                ...state.dailySleeps[displayName],
                [calendarDate]: {
                    ...state.dailySleeps[displayName][calendarDate],
                    dailySleepDTO: {
                        ...state.dailySleeps[displayName][calendarDate].dailySleepDTO,
                        userNote
                    }
                }
            }
        },
        noteUpdating: true
    };
};

const updateSleepNote = (state, action) => {
    const { userNote } = action;

    return {
        ...state,
        noteUpdating: INITIAL_STATE.noteUpdating,
        noteUpdateFailed: INITIAL_STATE.noteUpdateFailed,
        lastNote: userNote
    };
};

const updateSleepNoteFail = (state, action) => {
    const { displayName, calendarDate } = action;

    return {
        ...state,
        dailySleeps: {
            ...state.dailySleeps,
            [displayName]: {
                ...state.dailySleeps[displayName],
                [calendarDate]: {
                    ...state.dailySleeps[displayName][calendarDate],
                    dailySleepDTO: {
                        ...state.dailySleeps[displayName][calendarDate].dailySleepDTO,
                        userNote: state.lastNote
                    }
                }
            }
        },
        noteUpdating: INITIAL_STATE.noteUpdating,
        noteUpdateFailed: true
    };
};

const handlers = {
    [FETCH_WELLNESS_DAILY_SLEEP_DATA_FETCHING]: fetchDailySleepDataFetching,
    [FETCH_WELLNESS_DAILY_SLEEP_DATA_SUCCESS]: fetchDailySleepDataSuccess,
    [FETCH_WELLNESS_DAILY_SLEEP_DATA_FAIL]: fetchDailySleepDataFail,
    [UPDATE_WELLNESS_SLEEP_NOTE_START]: updateSleepNoteStart,
    [UPDATE_WELLNESS_SLEEP_NOTE_SUCCESS]: updateSleepNote,
    [UPDATE_WELLNESS_SLEEP_NOTE_FAIL]: updateSleepNoteFail
};

export default function dailySleepData(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

export const getDailySleepData = (state, displayName, calendarDate) => {
    return state.dailySleepData.dailySleeps[displayName]
        ? state.dailySleepData.dailySleeps[displayName][calendarDate]
        : null;
};

export const isDailySleepDataFetching = (state) => {
    const isFetchingArray = Object.values(state.dailySleepData.isFetching);
    return isFetchingArray.find((user) => {
        const calendarDates = Object.values(user);
        return calendarDates && calendarDates.find((isFetchingForDate) => isFetchingForDate === true);
    });
};

export const isDailySleepDataFetchFail = (state) => {
    const fetchFailedArray = Object.values(state.dailySleepData.fetchFailed);
    return fetchFailedArray.find((user) => {
        const calendarDates = Object.values(user);
        return calendarDates && calendarDates.find((fetchFailedForDate) => fetchFailedForDate === true);
    });
};

export const hasNoteUpdateFailed = (state) => {
    return state.dailySleepData.noteUpdateFailed;
};

export const isDailySleepDataFetchingByNameAndDate = (state, displayName, calendarDate) => {
    return state.dailySleepData.isFetching[displayName]
        ? state.dailySleepData.isFetching[displayName][calendarDate]
        : false;
};

export const isDailySleepDataFetchFailByNameAndDate = (state, displayName, calendarDate) => {
    return state.dailySleepData.fetchFailed[displayName]
        ? state.dailySleepData.fetchFailed[displayName][calendarDate]
        : false;
};
